import { useState } from "react";
import { getBaseRequest, postBaseRequest, putBaseRequest, deleteBaseRequest } from "../config/axiosClient";
import { handleFetch } from "../config/helpers";
import useAlert from "./useAlert";


const useFetch = (showSuccessAlert = true) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState(null);
    const [response, setResponse] = useState(null);
    const [error, setError] = useState(false);
    const { topBottomLeftAlert, customAlert, topMiddleAlert } = useAlert();

    const get = async (url) => {
        setLoading(true);
        const req = await handleFetch(getBaseRequest(url));
        setResponse(req);
        if (req.status == 'success') {
            setData(req.data);
            setError(false);
            if (showSuccessAlert) {
                topMiddleAlert('SUCCESS', req.message);
            }
        } else if (req.status == 'warning') {
            topMiddleAlert('WARNING', req.message);
            setError(req.message);
        } else if (req.status == 'failed') {
            setError(req.message);
            topMiddleAlert('ERROR', req.message);
        } else {
            setError(req.message);
            topMiddleAlert('ERROR', req.message);
        }
        setLoading(false);
        return req;
    }

    const post = async (url, data, showSuccessAlert = true, showErrorAlert = true, responseType = 'json') => {
        setLoading(true);
        setResponse(null);
        const req = await handleFetch(postBaseRequest(url, data, responseType));
        setResponse(req);
        if (req.status == 'success') {
            setData(req.data);
            setError(false);
            if (showSuccessAlert) {
                topMiddleAlert('SUCCESS', req.message);
            }
        } else if (req.status == 'warning') {
            setError(req.message);
            if (showErrorAlert) {
                topMiddleAlert('WARNING', req.message);
            }
        } else if (req.status == 'failed') {
            setError(req.message);
            if (showErrorAlert) {
                topMiddleAlert('ERROR', req.message);
            }
        } else {
            setError(req.message);
            if (showErrorAlert) {
                topMiddleAlert('ERROR', req.message);
            }
        }
        setLoading(false);
        return req;
    }

    const put = async (url, data, showSuccessAlert = true, showErrorAlert = true) => {
        setLoading(true);
        setResponse(null);
        const req = await handleFetch(putBaseRequest(url, data));
        setResponse(req);
        if (req.status == 'success') {
            setData(req.data);
            setError(false);
            if (showSuccessAlert) {
                topMiddleAlert('SUCCESS', req.message);
            }
        } else if (req.status == 'warning') {
            setError(req.message);
            if (showErrorAlert) {
                topMiddleAlert('WARNING', req.message);
            }
        } else if (req.status == 'failed') {
            setError(req.message);
            if (showErrorAlert) {
                topMiddleAlert('ERROR', req.message);
            }
        } else {
            setError(req.message);
            if (showErrorAlert) {
                topMiddleAlert('ERROR', req.message);
            }
        }
        setLoading(false);
        return req;
    }

    const del = async (url, showSuccessAlert = true, showErrorAlert = true) => {
        setLoading(true);
        setResponse(null);
        const req = await handleFetch(deleteBaseRequest(url));
        setResponse(req);
        if (req.status == 'success') {
            setData(req.data);
            setError(false);
            if (showSuccessAlert) {
                topMiddleAlert('SUCCESS', req.message);
            }
        } else if (req.status == 'warning') {
            setError(req.message);
            if (showErrorAlert) {
                topMiddleAlert('WARNING', req.message);
            }
        } else if (req.status == 'failed') {
            setError(req.message);
            if (showErrorAlert) {
                topMiddleAlert('ERROR', req.message);
            }
        } else {
            setError(req.message);
            if (showErrorAlert) {
                topMiddleAlert('ERROR', req.message);
            }
        }
        setLoading(false);
        return req;
    }

    return {
        get,
        post,
        put,
        del,
        data, response, loading, error, setLoading, setData, setResponse
    }
}

export default useFetch;